import { ADMIN_REVIEW_CYCLE_EDIT, ADMIN_REVIEWS_WITH_CYCLE, REVIEWS_COMPANY_CYCLE_PRINT } from '../../../../routes';
import { goToUrl } from '../../../services/Router';
import { interpolateAppUrl } from '../../../services/Url';

export const getPreviewQuestionnaireActionUrls = cycleId => ({
    CYCLE_SETTINGS: interpolateAppUrl(ADMIN_REVIEW_CYCLE_EDIT, { cycleId }),
    CYCLE_OVERVIEW: interpolateAppUrl(ADMIN_REVIEWS_WITH_CYCLE, { cycleId }),
});
export const getCompanyCycleUrl = cycleId => interpolateAppUrl(ADMIN_REVIEWS_WITH_CYCLE, { cycleId });
export const getCompanyCyclePrintUrl = cycleId => interpolateAppUrl(REVIEWS_COMPANY_CYCLE_PRINT, { cycleId });
export const getTeamCycleUrl = (userId, cycleId) => `/app/team/reviews/${userId}/${cycleId}`;

export const getEditUrl = (id, options = {}) =>
    `/app/reviews/edit/${id}${options.editAs ? `?editAs=${options.editAs}` : ''}`;

export const getViewUrl = id => `/app/reviews/view/${id}`;

export const redirectToViewOnAction = (review, assessmentType, actionType) => {
    goToUrl(getViewUrl(review.id), { assessmentType, actionType });
};
